export const DEFAULT_EXPLORE_URL = 'https://kswap.web3s.finance'